import type { Router } from 'vue-router';

export default (e: MouseEvent, router: Router) => {
  const target = e.target as HTMLElement;

  if (target.tagName === 'A') {
    // don't push/replace with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
      return;
    }

    const linkTarget = target.getAttribute('target') || '';
    const download = target.getAttribute('download') || '';
    const rel = target.getAttribute('rel') || '';
    const shouldReplace = target.getAttribute('data-replace') !== null;
    const reloadOnSame = target.getAttribute('data-reload') !== null;

    const href = target.getAttribute('href') || '';

    // we must follow links which have `target`, `download` or `rel="external"` attributes
    if (linkTarget !== '' || download !== '' || rel.includes('external')) {
      return;
    }

    if (href.startsWith('/')) {
      if (reloadOnSame && href === router.currentRoute.value.fullPath) {
        router.go(0);
      }

      if (shouldReplace) {
        void router.replace(href);
      } else {
        void router.push(href);
      }

      e.stopPropagation();
      e.preventDefault();
      return;
    }

    if (href === '') {
      e.preventDefault();
    }
  }
};
